export const ExternalPicklistTypeEnum = {
  Enrollment: 'enrollment',
  Benchmark: 'benchmark',
  Country: 'country',
  States: 'states',
  FactorTilt: 'factorTilt',
  TiltImportanceOption: 'tiltimptoption',
  Account: 'account',
  Strategy: 'strategy',
};

export const ExternalPicklistEnum = {
  StateList: 'UAP_STATE_LIST',
  EntityType: 'UAP_ENTITY_TYPE',
  AccountName: 'UAP_USER_ACCOUNT_NAME',
  CustodianNumber: 'UAP_USER_ACCOUNT_CUSTODIAN_NUMBER',
  AccountClient: 'UAP_USER_ACCOUNT_CLIENT',
  AccountCustodian: 'UAP_USER_ACCOUNT_CUSTODIAN',
  RelationshipAdvisor: 'UAP_USER_ACCOUNT_RELATIONSHIP_ADVISOR',
  BlendableBenchmark: 'UAP_BLENDABLE_BENCHMARK',
  UserBlendableBenchmark: 'UAP_USER_BLENDABLE_BENCHMARK',
};
